import * as React from "react";

import { ReferralReportVersion } from "@teamprevent/common/referralReport/models";

import { PpqReport } from "../../Ppq";
import { HealthSurveillanceCertificate } from "../../healthSurveillance/certificate/components/HealthSurveillanceCertificate";
import { ImmunisationClearCertificate } from "../../immunisation/components/ImmunisationClearCertificate";
import {
    AllImmsCompletedForRoleCertificate
} from "../../Ppq/components/AllImmsCompletedForRoleCertificate";
import { InitialWorkAdjustmentQuestionnaire } from "../../workAdjustment/components/InitialWorkAdjustmentQuestionnaire";
import { UpdateWorkAdjustmentQuestionnaire } from "../../workAdjustment/components/UpdateWorkAdjustmentQuestionnaire";
import { ManagerFeedbackOnReportForm } from "../../managerFeedbackOnReport/components/ManagerFeedbackOnReportForm";
import { SatisfactionFollowUpQuestionnaire } from "../../managerSatisfactionFollowUpQuestionnaire/components/SatisfactionFollowUpQuestionnaire";
import { MHPTreatmentReportDetail } from "../../mentalHealthPractitionerTreatment/components/MHPTreatmentReportDetail";

import { ActionableTaskList } from "./actionableTaskList";
import { InsufficientInformationDetail } from "./InsufficientInformationDetail";
import { ReportDetail } from "./ReportDetail";
import { PhysiotherapyReportDetailV2 } from "./PhysiotherapyReportDetailV2";
import { PhysiotherapyReportDetail as PhysiotherapyReportDetailV3 } from "./PhysiotherapyReportDetailV3";

import { PhysiotherapyReportDetail } from "./PhysiotherapyReportDetailV4";

import { Fragment } from "redux-little-router";

export class Base extends React.Component {
    public render() {
        return (
            <>
                <Fragment forRoute="/:ohCaseId/insufficient-information/:taskId">
                    <InsufficientInformationDetail />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-old-report/1/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V1}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-write-old-report/1/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V1}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-old-report/2/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V2}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-write-old-report/2/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V2}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-old-report/3/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V3}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-write-old-report/3/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.V3}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-report/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.Latest}
                        oldVersionRedirectUrl={"/actions/:ohCaseId/view-old-report/:version/:viewReportTaskId"}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-write-report/:viewReportTaskId">
                    <ReportDetail
                        version={ReferralReportVersion.Latest}
                        oldVersionRedirectUrl={"/actions/:ohCaseId/view-write-old-report/:version/:viewReportTaskId"}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-ppq-report/:viewReportTaskId">
                    <PpqReport />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-health-surveillance-certificate/:taskId">
                    <HealthSurveillanceCertificate />
                </Fragment>
                <Fragment forRoute="/:employeeRecordId/:ohCaseId/all-imms-completed-for-role-certificate/:taskId">
                    <AllImmsCompletedForRoleCertificate />
                </Fragment>
                <Fragment forRoute="/:employeeRecordId/:ohCaseId/immunisation-clear-certificate/:taskId">
                    <ImmunisationClearCertificate />
                </Fragment>

                {/* Route for V3 needs to come before wildcard route */}
                <Fragment forRoute="/:ohCaseId/view-write-old-physiotherapy-report/3/:viewReportTaskId">
                    <PhysiotherapyReportDetailV3 version={ReferralReportVersion.V3} />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-old-physiotherapy-report/3/:viewReportTaskId">
                    <PhysiotherapyReportDetailV3 version={ReferralReportVersion.V3} />
                </Fragment>

                <Fragment forRoute="/:ohCaseId/view-write-old-physiotherapy-report/*/:viewReportTaskId">
                    <PhysiotherapyReportDetailV2 />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-old-physiotherapy-report/*/:viewReportTaskId">
                    <PhysiotherapyReportDetailV2 />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-physiotherapy-report/:viewReportTaskId">
                    <PhysiotherapyReportDetail
                        version={ReferralReportVersion.Latest}
                        oldVersionRedirectUrl={"/actions/:ohCaseId/view-old-physiotherapy-report/:version/:viewReportTaskId"}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-write-physiotherapy-report/:viewReportTaskId">
                    <PhysiotherapyReportDetail
                        version={ReferralReportVersion.Latest}
                        oldVersionRedirectUrl={"/actions/:ohCaseId/view-write-old-physiotherapy-report/:version/:viewReportTaskId"}
                    />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/view-mhp-treatment-report/:viewReportTaskId">
                    <MHPTreatmentReportDetail />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/complete-initial-work-adjustment-details/:taskId">
                    <InitialWorkAdjustmentQuestionnaire />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/process-update-work-adjustment-questionnaire/:taskId">
                    <UpdateWorkAdjustmentQuestionnaire />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/manager-feedback-on-report/:taskId">
                    <ManagerFeedbackOnReportForm />
                </Fragment>
                <Fragment forRoute="/:ohCaseId/follow-up-questionnaire/:taskId">
                    <SatisfactionFollowUpQuestionnaire />
                </Fragment>
                <Fragment forRoute="/">
                    <ActionableTaskList />
                </Fragment>
            </>
        );
    }
}
